import React from 'react';
import OurTeachers from '../components/ourteachers/OurTeachers';
import BannerHero from '../components/bannerHero';
import ContactArea from '../components/ContactArea';

const Teachers: React.FC = () => {
  return (
    <>
      <BannerHero
        title="Our Teachers"
        bgImage="/images/teachers/banner-bg.png"
        className="teachers"
      />
      <OurTeachers />
      {/* <ContactArea /> */}
    </>
  );
};

export default Teachers;
